import React from 'react';
import { IconProps, IconWrapper } from '../lib/icons';

interface InlineMessageProps {
  actions?: React.ReactElement[];
  iconName?: IconProps['name'];
  iconSize?: IconProps['size'];
  title?: string;
  text?: string | React.ReactElement;
}

const InlineMessage = (props: InlineMessageProps) => {
  const {actions, iconName, iconSize, title, text} = props;

  return (
    <div className="inline-message">
      {
        iconName && (
          <div className="icon">
            <IconWrapper name={iconName} size={iconSize || 'extralarge'} color="primary" pointer />
          </div>
        )
      }
      <div className="right">
        {title && <h3>{title}</h3>}
        <div className="text">
          {text}
        </div>

        {actions && <div className="actions">{actions}</div>}
      </div>
    </div>
  )
}

export default InlineMessage;
